import Vue from 'vue'
import Axios from 'axios';

var login = new Vue({
    el: '#login',

    data: {
        email: '',
        password: '',
        formSent: false,
        errorMessage: '',
        successMessage: '',
        showPasswordForm: false,
    },

    methods: {
        requestPassword: function() {
            let self = this;
            self.formSent = true;
            if(self.email == '') {
                self.errorMessage = 'Bitte gib Deine E-Mail Adresse an';
                self.formSent = false;
            }

            Axios.post('/fg/Login/RequestPassword', { email: self.email })
            .then(function(response) {
                self.formSent = false;           
                self.successMessage = '';
                self.errorMessage = '';
                if(response.data == "") {
                    self.showPasswordForm = false;
                    self.successMessage = 'Es wurde ein neues Passwort an Deine E-Mail Adresse gesendet'
                } else {
                    self.errorMessage = response.data;
                    window.scrollTo(0,0);
                }                
            })
            .catch(function(error) {
                self.errorMessage = 'Es ist ein Fehler aufgetreten';
                self.formSent = false;
            });
        },

        sendForm: function() {
            let self = this;
            self.formSent = true;
            if(self.email == '' || self.password == '') {
                self.errorMessage = 'Die angegebenen Benutzerdaten sind nicht korrekt';
                self.formSent = false;
                window.scrollTo(0,0);
            }

            Axios.post('/fg/Login', { email: self.email, password: self.password })
            .then(function(response) {
                self.formSent = false;           
                if(response.data != "") {
                    window.location.href = response.data;
                } else {
                    self.errorMessage = 'Die angegebenen Benutzerdaten sind nicht korrekt';
                    window.scrollTo(0,0);
                }                
            })
            .catch(function(error) {
                self.errorMessage = 'Es ist ein Fehler aufgetreten';
                self.formSent = false;
                window.scrollTo(0,0);
            });
        },

        togglePasswordForm: function() {
            this.showPasswordForm = !this.showPasswordForm;
        },


    }
});


// WEBPACK FOOTER //
// ./Scripts/apps/login.js